import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeHelper } from '../../helper/theme.helper';
import { ThemeService } from '../../services/theme.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: 'app.footer.html'
})
export class AppFooter {

    themeData: ThemeHelper | undefined;

    constructor(
        private themeService: ThemeService,
    ) {
        this.themeService.themeData.subscribe({
            next: (data) => {
                this.themeData = data;
            }
        });
    }
}
